import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { JsonAgency, Agency } from '../../models'
import { getAgencies } from '../../api'
import { getAuthUser } from '../../helpers'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions, Loading } from '../common'

enum PageState {
    Default,
    Loading,
    Found,
    NotFound,
    AuthenticationError,
    Error
}

export const AgenciesUnknownSupplierLanding = () => {
    const [agencies, setAgencies] = useState<Agency[]>([])
    const ability = defineAbilityFor(getAuthUser())
    const [pageState, setPageState] = useState(PageState.Default)

    useEffect(() => {
        setPageState(PageState.Loading)

        getAgencies({ unknownSupplier: true })
            .then(json => {
                setPageState(PageState.Found)
                setAgencies(json.data.map((agency: JsonAgency) => new Agency(agency)))
            }).catch(error => {
                setPageState(PageState.Error)

                const { response } = error

                if (response?.status === 404) {
                    setPageState(PageState.NotFound)
                }
                if (response?.status === 401) {
                    setPageState(PageState.AuthenticationError)
                }
            })
    }, [])

    if (!ability.can('View', 'Agency')) {
        return <InsufficientPermissions />
    }

    return (
        <div className='container'>
            <h3>Agencies - Unknown Supplier</h3>
            <table className='table'>
            <tbody>
                <tr>
                    <th>Name</th>
                    <th>EIN</th>
                    <th>Street</th>
                    <th>City</th>
                    <th>State</th>
                    <th>Zip</th>
                    <th>Country</th>
                    <th>Records</th>
                    <th>Unknown Supplier</th>
                </tr>

                {pageState === PageState.Loading && (
                    <tr>
                    <td colSpan={9} className="text-center">
                        <Loading />
                    </td>
                    </tr>
                )}

                {pageState === PageState.AuthenticationError && (
                    <tr>
                    <td colSpan={9} className="text-center">
                        Session expired, please refresh.
                    </td>
                    </tr>
                )}

                {pageState === PageState.Error && (
                    <tr>
                    <td colSpan={9} className="text-center">
                        Something went wrong. Please try again.
                    </td>
                    </tr>
                )}

                {pageState === PageState.Found &&
                    agencies.map((agency) => (
                    <tr key={agency.id}>
                        <td>
                        <Link to={`/agencies/${agency.id}`}>
                            {agency.name}
                        </Link>
                        </td>
                        <td>{agency.ein}</td>
                        <td>{agency.physicalAddress.street}</td>
                        <td>{agency.physicalAddress.city}</td>
                        <td>{agency.physicalAddress?.state?.name}</td>
                        <td>{agency.physicalAddress.zip}</td>
                        <td>{agency.physicalAddress.country?.name}</td>
                        <td>{agency.recordCount}</td>
                        <td>
                        <Link to={`/records/unknownSupplier?agencyId=${agency.id}`}>
                            {agency.unknownSupplierRecordCount}
                        </Link>
                        </td>
                    </tr>
                    ))}
            </tbody>
            </table>
        </div>
    )
}
